import { useTranslation } from 'react-i18next';

interface CookieBannerProps {
  visible: boolean;
  onAccept: () => void;
  onReject: () => void;
  policyHref: string;
}

export function CookieBanner({
  visible,
  onAccept,
  onReject,
  policyHref,
}: CookieBannerProps) {
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <div
      className="border-t border-gray-200 bg-white"
      style={{ position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 50 }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-center">
          <div className="text-sm text-gray-700 max-w-3xl">
            <span className="font-semibold text-gray-900">{t('cookies.title')}</span>{' '}
            {t('cookies.description')}{' '}
            <a href={policyHref} className="text-teal-600 hover:text-teal-700 underline">
              {t('cookies.policy')}
            </a>
          </div>
          <div className="flex gap-3 justify-center">
            <button
              type="button"
              onClick={onReject}
              className="px-4 py-2 rounded-lg border border-gray-200 text-gray-700 hover:bg-gray-50 text-sm font-medium"
            >
              {t('cookies.reject')}
            </button>
            <button
              type="button"
              onClick={onAccept}
              className="px-4 py-2 rounded-lg bg-teal-600 text-white hover:bg-teal-700 text-sm font-semibold"
            >
              {t('cookies.accept')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
